// extracted by mini-css-extract-plugin
export default {"butonatDiv":"Buton_butonatDiv__KWvOd","buttonat":"Buton_buttonat__iYgZw","butoniAddToCart":"Buton_butoniAddToCart__-crfu"};